module.exports = __webpack_public_path__ + "static/media/AI_5.31b158cc.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/AI_5.png
// module id = 120
// module chunks = 0